import { ReactNode } from "react";
import { Sparkles, MapPinned } from "lucide-react";
import { SectionTooltip } from "./SectionTooltip";

export type SectionType = "express" | "para-voce" | "outros";

interface SectionHeaderProps {
  type: SectionType;
  disabled?: boolean;
}

const sectionConfig = {
  express: {
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        style={{ flexShrink: 0 }}
      >
        <path
          d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"
          fill="#56289E"
          stroke="#56289E"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Express",
    subtitle: "Clientes que pagaram para ter destaque",
    color: "#6b34bf",
    tooltip:
      "Pedidos Express foram feitos por clientes que pagaram para ter maior visibilidade, indicando maior interesse em contratar o serviço.",
  },
  "para-voce": {
    icon: (
      <Sparkles
        className="w-[18px] h-[18px]"
        style={{
          color: "#059669",
          fill: "#059669",
          flexShrink: 0,
          strokeWidth: 1.5,
        }}
      />
    ),
    title: "Para você",
    subtitle: "Baseado no seu histórico",
    color: "#059669",
    tooltip:
      "Pedidos selecionados com base no seu histórico de liberações e avaliações.",
  },
  outros: {
    icon: (
      <MapPinned
        className="w-[18px] h-[18px]"
        style={{
          color: "#6b7280",
          flexShrink: 0,
          strokeWidth: 2.5,
        }}
      />
    ),
    title: "Outros pedidos",
    subtitle: "Disponíveis perto de você",
    color: "#6b7280",
    tooltip:
      "Todos os demais pedidos disponíveis na sua região e categoria.",
  },
};

export function SectionHeader({
  type,
  disabled = false,
}: SectionHeaderProps) {
  const config = sectionConfig[type];

  return (
    <div
      className="flex items-start justify-between"
      style={{
        opacity: disabled ? 0.5 : 1,
        transition: "opacity 0.2s ease",
        backgroundColor: "transparent",
      }}
    >
      <div
        className="flex items-start gap-2"
        style={{ flex: 1, minWidth: 0 }}
      >
        <div style={{ paddingTop: "2px" }}>{config.icon}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h2
            style={{
              fontSize: "var(--text-sm)",
              fontWeight: "var(--font-weight-semibold)",
              lineHeight: "1.5",
              color: config.color,
            }}
          >
            {config.title}
          </h2>
          <p
            style={{
              fontSize: "var(--text-xs)",
              fontWeight: "var(--font-weight-normal)",
              lineHeight: "1.4",
              color: "var(--muted-foreground)",
            }}
          >
            {config.subtitle}
          </p>
        </div>
      </div>
      <div style={{ paddingTop: "2px" }}>
        <SectionTooltip
          content={config.tooltip}
          disabled={disabled}
          color={config.color}
        />
      </div>
    </div>
  );
}

// Export config for use in sticky header
export { sectionConfig };